import { defineMessages } from '@jutro/locale';

export default defineMessages({
    makeChanges: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.makeChanges',
        defaultMessage: 'Make Changes',
    },
    needMakeChanges: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.needMakeChanges',
        defaultMessage: 'Need to make additional changes?',
    },
    continueP: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.continueP',
        defaultMessage: 'If not, click CONTINUE to submit your change or select another option below.',
    },
    savingEndorsement: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.savingEndorsement',
        defaultMessage: 'Saving endorsement...',
    },
    nextDescriptionPolSummary: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.nextDescriptionPolSummary',
        defaultMessage: 'We\'ll review the {bold} next',
    },
    nextDescriptionAddlPolInfo: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.nextDescriptionAddlPolInfo',
        defaultMessage: 'We\'ll review {bold} next',
    },
    nextBoldPolSummary: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.nextBoldPolSummary',
        defaultMessage: 'policy summary and premium',
    },
    nextBoldAddlPolInfo: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.nextBoldAddlPolInfo',
        defaultMessage: 'additional policy information',
    },
    trailerError: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.trailerError',
        defaultMessage: 'We\'re sorry, we are unable to have a trailer as the only vehicle on your policy. You can contact customer service by chat or call us at 1-888-332-0460. When contacting us, please include your quote number.',
    },
    trailerErrorQnB: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.trailerErrorQnB',
        defaultMessage: 'We\'re sorry, we are unable to have a trailer as the only vehicle on your policy. You can contact customer service by call us at 1-888-332-0460. When contacting us, please include your quote number.',
    },
    quotingPolicyChange: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.quotingPolicyChange',
        defaultMessage: 'Quoting Policy Change',
    },
    undo: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Undo',
        defaultMessage: ' Undo'
    },
    driverHasBeenAddedAsHouseholdMember: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Driver has been added as a household member',
        defaultMessage: '{strongName} has been added as a household member.'
    },
    driverHasBeenAddedAsNonDriver: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Driver has been added as a non driver',
        defaultMessage: '{strongName} has been added as a non driver.'
    },
    notValidReason: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Not a valid reason',
        defaultMessage: 'The reason selected is not a valid reason to remove this non driver.'
    },
    notValidReasonToRemoveExcludedMember: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.The reason selected is not a valid reason to remove this Excluded member.',
        defaultMessage: 'The reason selected is not a valid reason to remove the exclusion.'
    },
    driverExcludedNotCovered: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Driver has been excluded and will not be covered',
        defaultMessage: '{strongName} has been excluded and will not be covered.'
    },
    driverHasBeenRemoved: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Driver has been removed',
        defaultMessage: '{strongName} has been removed.'
    },
    driver: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Driver',
        defaultMessage: 'Driver'
    },
    drivers: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Drivers',
        defaultMessage: 'Drivers'
    },
    excludedDriver: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Excluded Driver',
        defaultMessage: 'Excluded driver'
    },
    excludedDrivers: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Excluded Drivers',
        defaultMessage: 'Excluded drivers'
    },
    householdMember: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Household Member',
        defaultMessage: 'Household Member'
    },
    householdMembers: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Household Members',
        defaultMessage: 'Household Members'
    },
    nonDriver: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Non Driver',
        defaultMessage: 'Non Driver'
    },
    nonDrivers: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Non Drivers',
        defaultMessage: 'Non Drivers'
    },
    driverHasBeenAdded: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Driver has been added',
        defaultMessage: '{strongName} has been added.'
    },
    businessActivityXHasBeenAdded: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Business Activity x has been added',
        defaultMessage: 'Business Activity {strongName} has been added.'
    },
    businessActivityXHasBeenRemoved: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Business Activity x has been removed',
        defaultMessage: 'Business activity {strongName} has been removed.'
    },
    businessActivityHasBeenRemoved: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Business Activity  has been removed',
        defaultMessage: 'Business activity has been removed.'
    },
    removeBusinessActivity: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Remove Business Activity',
        defaultMessage: 'Remove Business Activity'
    },
    removePolicy: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Remove Policy',
        defaultMessage: 'Remove Policy'
    },
    removeWatercraft: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Remove Watercraft',
        defaultMessage: 'Remove Watercraft'
    },
    removeWatercraftOperator: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Remove Watercraft Operator',
        defaultMessage: 'Remove Watercraft Operator'
    },
    xHasBeenAdded: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.x has been added',
        defaultMessage: '{strongName} has been added.'
    },
    xHasBeenRemoved: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.x has been removed',
        defaultMessage: '{strongName} has been removed.'
    },
    vehicleHasBeenRemoved:{
        id:'ml.endorsement.pa.directives.templates.addlChanges.Vehicle has been removed',
        defaultMessage:'{strongName} will be removed. {linebreak} {nextline} '
    },
    vehicleAdditionalMessages:{
        id:'ml.endorsement.pa.directives.templates.addlChanges.Vehicle Additional Message',
        defaultMessage:"There are no vehicles listed on this policy. If customer owns a vehicle, please add it now. Otherwise, drivers listed will be covered for Liability insurance only when they drive vehicles they don't own."
    },
    removeLocation: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Remove Locations',
        defaultMessage: 'Remove Locations'
    },
    xLocationHasBeenRemoved: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.x location has been removed',
        defaultMessage: '{strongName} location has been removed.'
    },
    xLocationHasBeenAdded: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.x location has been added',
        defaultMessage: '{strongName} location has been added.'
    },
    xVehicleWillBeRemoved:{
        id:'ml.endorsement.pa.directives.templates.addlChanges.x vehicle will be removed',
        defaultMessage:'{strongName} will be removed.'
    },
    removeVehicle:{
        id:'ml.endorsement.pa.directives.templates.addlChanges.Remove Vehicle',
        defaultMessage:'Remove Vehicle'
    },
    watercraftXHasBeenRemoved:{
        id: 'ml.endorsement.pa.directives.templates.addlChanges.x watercraft has been removed',
        defaultMessage: '{strongName} has been removed.'
    },
    watercraftXHasBeenAdded: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.x watercraft has been added',
        defaultMessage: '{strongName} has been added.'
    },
    watercraftOperatorXHasBeenRemoved: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.x watercraft operator has been added',
        defaultMessage: '{strongName} has been removed.'
    },
    watercraftoperatorXHasBeenAdded: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.x watercraft operator has been added',
        defaultMessage: '{strongName} has been added.'
    },
    continue: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Continue',
        defaultMessage: 'Continue'
    },
    addDriver: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Add Driver',
        defaultMessage: 'Add Driver'
    },
    addANewDriver: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Add a new driver',
        defaultMessage: 'Add a new driver'
    },
    editDriver: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Edit Driver',
        defaultMessage: 'Edit Driver'
    },
    addVehicle: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Add Vehicle',
        defaultMessage: 'Add Vehicle'
    },
    duplicatedVinFlag: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.This VIN number has already been listed for another vehicle.',
        defaultMessage: 'This VIN has already been listed for another vehicle.'
    },
    replaceVehicle: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.Replace vehicle',
        defaultMessage: 'Replace vehicle'
    },
    vehicleReplaced:{
        id:'ml.endorsement.pa.directives.templates.addlChanges.Vehicle Replace Message',
        defaultMessage:'<strong>{vehicleName}</strong> will be removed from the policy. Please add the replacement vehicle below.'
    },
    exlcusionNotAllowed: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.The reason selected is not a valid reason to remove this driver.',
        defaultMessage: 'The reason selected is not a valid reason to remove this driver. We require this person to be listed as a driver.'
    },
    driverChangedToRatedPlsUpdateDriver: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.driverChangedToRatedPlsUpdateDriver',
        defaultMessage: 'Driver successfully changed to rated. Please update driver details.'
    },
    loadingDriverDiscovery: {
        id: 'ml.endorsement.pa.directives.templates.addlChanges.loadingDriverDiscovery',
        defaultMessage: 'Loading Driver Discovery...',
    },
    NonDriversTooltip: {
    id: "ml.endorsement.wizard.step.Non Drivers ToolTip",
    defaultMessage: "Add, update or Remove Non Drivers."
    }
    
});
